import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicStorageBlockVolumeListResultRawI,
	type LWApiPublicStorageBlockVolumeListParamsRawI,
} from '@liquidweb-dev/club-sauce/public/storage/block/volume/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const STORAGE_BLOCK_VOLUME_LIST_QUERY_KEY = '/storage/block/volume/list';

const useStorageBlockVolumeList = (
	params: LWApiPublicStorageBlockVolumeListParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicStorageBlockVolumeListResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [STORAGE_BLOCK_VOLUME_LIST_QUERY_KEY, params],
		queryFn: () => api.storage.block.volume.apiRaw.list(params),
		...options,
	});

export default useStorageBlockVolumeList;
